/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateLayoverCategoryRequest } from '../models/create-layover-category-request';
import { GenericResponse } from '../models/generic-response';
import { GetLayoverCategoryResponse } from '../models/get-layover-category-response';
import { LayoverCategoryResponse } from '../models/layover-category-response';
import { UpdateLayoverCategoryRequest } from '../models/update-layover-category-request';

/**
 * Layover category master APIs
 */
@Injectable({ providedIn: 'root' })
export class LayoverCategoryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllLayoverCategory()` */
  static readonly GetAllLayoverCategoryPath = '/api/v1/layover-categories';

  /**
   * Get list of layover categorys.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllLayoverCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllLayoverCategory$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * search layover category name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetLayoverCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      LayoverCategoryService.GetAllLayoverCategoryPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetLayoverCategoryResponse>;
        })
      );
  }

  /**
   * Get list of layover categorys.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllLayoverCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllLayoverCategory(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * search layover category name
       */
      search?: string;
    },
    context?: HttpContext
  ): Observable<GetLayoverCategoryResponse> {
    return this.getAllLayoverCategory$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetLayoverCategoryResponse>
        ): GetLayoverCategoryResponse => r.body
      )
    );
  }

  /** Path part for operation `createLayoverCategory()` */
  static readonly CreateLayoverCategoryPath = '/api/v1/layover-categories';

  /**
   * Create layover category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createLayoverCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLayoverCategory$Response(
    params: {
      body: CreateLayoverCategoryRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<LayoverCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      LayoverCategoryService.CreateLayoverCategoryPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<LayoverCategoryResponse>;
        })
      );
  }

  /**
   * Create layover category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createLayoverCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createLayoverCategory(
    params: {
      body: CreateLayoverCategoryRequest;
    },
    context?: HttpContext
  ): Observable<LayoverCategoryResponse> {
    return this.createLayoverCategory$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<LayoverCategoryResponse>
        ): LayoverCategoryResponse => r.body
      )
    );
  }

  /** Path part for operation `getLayoverCategoryById()` */
  static readonly GetLayoverCategoryByIdPath =
    '/api/v1/layover-categories/{id}';

  /**
   * Get layover category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLayoverCategoryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLayoverCategoryById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<LayoverCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      LayoverCategoryService.GetLayoverCategoryByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<LayoverCategoryResponse>;
        })
      );
  }

  /**
   * Get layover category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLayoverCategoryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLayoverCategoryById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<LayoverCategoryResponse> {
    return this.getLayoverCategoryById$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<LayoverCategoryResponse>
        ): LayoverCategoryResponse => r.body
      )
    );
  }

  /** Path part for operation `deleteLayoverCategory()` */
  static readonly DeleteLayoverCategoryPath = '/api/v1/layover-categories/{id}';

  /**
   * Delete layover category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteLayoverCategory()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLayoverCategory$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      LayoverCategoryService.DeleteLayoverCategoryPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * Delete layover category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteLayoverCategory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteLayoverCategory(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.deleteLayoverCategory$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `updateLayoverCategory()` */
  static readonly UpdateLayoverCategoryPath = '/api/v1/layover-categories/{id}';

  /**
   * Update layover category by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateLayoverCategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLayoverCategory$Response(
    params: {
      id: number;
      body: UpdateLayoverCategoryRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<LayoverCategoryResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      LayoverCategoryService.UpdateLayoverCategoryPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<LayoverCategoryResponse>;
        })
      );
  }

  /**
   * Update layover category by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateLayoverCategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateLayoverCategory(
    params: {
      id: number;
      body: UpdateLayoverCategoryRequest;
    },
    context?: HttpContext
  ): Observable<LayoverCategoryResponse> {
    return this.updateLayoverCategory$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<LayoverCategoryResponse>
        ): LayoverCategoryResponse => r.body
      )
    );
  }
}
